import { initializeApp } from "firebase/app";
import { firebaseConfig } from "src/config/firebase";
import { initializeFirestore } from "firebase/firestore";

export const firebaseApp = initializeApp(firebaseConfig);
initializeFirestore(firebaseApp, {
  ignoreUndefinedProperties: true,
});
